<template>
  <div class="bg-white shadow p-4 sm:p-6 overflow-hidden sm:rounded-md border border-gray-200">
    <div>
      <div class="flex sm:mb-6 mb-4">
        <span
          class="rounded-lg w-12 mr-4 h-12 p-3 flex justify-center align-middle items-center bg-indigo-50 text-indigo-700"
        >
          <SparklesIcon class="text-spark-purple h-7 w-7" />
        </span>
        <div class="sm:flex sm:items-center sm:justify-between">
          <div>
            <h3 class="text-sm font-medium text-gray-6000">
              Popular upgrades
            </h3>
            <div class="mt-1 pr-8 text-sm text-gray-500">
              <p>
                Level-up your B2B store with our
                <span class="hidden sm:inline">selection of SparkLayer</span>
                upgrades.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid gap-6 grid-cols-1 sm:grid-cols-3">
      <div class="bg-white shadow rounded-lg border border-gray-200">
        <div class="h-full block">
          <div class="">
            <img
              src="https://i.ibb.co/fXL1qFp/upgrade-1.png"
              class="block cursor-pointer w-full h-auto border-b rounded-tl-lg rounded-tr-lg"
              alt="SparkLayer"
              tabindex="0"
              @click="openArchbee('Uw8mDbMEfwWKqZrVB5CqX')"
              @keyup.enter.space="openArchbee('Uw8mDbMEfwWKqZrVB5CqX')"
            >
            <div class="p-6">
              <dl>
                <dt class="text-sm font-medium text-gray-600">
                  Sales Agent Ordering
                </dt>
                <dd>
                  <div class="mt-1 mb-3 text-sm text-gray-500">
                    Empower your sales team to place orders on behalf of your B2B customers
                    and fully manage their accounts.
                    <a
                      rel="noopener noreferrer"
                      class="font-medium inline-flex items-center cursor-pointer text-indigo-600 hover:text-indigo-500"
                      tabindex="0"
                      @click="openArchbee('Uw8mDbMEfwWKqZrVB5CqX')"
                      @keyup.enter.space="openArchbee('Uw8mDbMEfwWKqZrVB5CqX')"
                    >
                      <span>Learn more</span>
                      <ExternalLinkIcon class="group-hover:text-spark-purple ml-1 h-4 w-4" />
                    </a>
                  </div>
                  <div class="md:flex block gap-3">
                    <router-link
                      to="/settings/plan"
                      class="inline-flex items-center cursor-pointer trigger-intercom-install px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <SparklesIcon class="group-hover:text-spark-purple mr-2 h-5 w-5" />
                      <span>Upgrade</span>
                    </router-link>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white shadow rounded-lg border border-gray-200">
        <div class="h-full block">
          <div class="">
            <img
              src="https://i.ibb.co/6HDdCWL/upgrade-2.png"
              class="block cursor-pointer w-full h-auto border-b rounded-tl-lg rounded-tr-lg"
              alt="SparkLayer"
              tabindex="0"
              @click="openArchbee('_WwfeWVJY9xrSuNCQlFoZ')"
              @keyup.enter.space="openArchbee('_WwfeWVJY9xrSuNCQlFoZ')"
            >
            <div class="p-6">
              <dl>
                <dt class="text-sm font-medium text-gray-600">
                  Company Users
                </dt>
                <dd>
                  <div class="mt-1 mb-3 text-sm text-gray-500">
                    Enable customers to create teams to share activities
                    such as placing orders and managing addresses.
                    <a
                      rel="noopener noreferrer"
                      class="font-medium inline-flex items-center cursor-pointer text-indigo-600 hover:text-indigo-500"
                      tabindex="0"
                      @click="openArchbee('_WwfeWVJY9xrSuNCQlFoZ')"
                      @keyup.enter.space="openArchbee('_WwfeWVJY9xrSuNCQlFoZ')"
                    >
                      <span>Learn more</span>
                      <ExternalLinkIcon class="group-hover:text-spark-purple ml-1 h-4 w-4" />
                    </a>
                  </div>
                  <div class="md:flex block gap-3">
                    <router-link
                      to="/settings/plan"
                      class="inline-flex items-center cursor-pointer trigger-intercom-install px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <SparklesIcon class="group-hover:text-spark-purple mr-2 h-5 w-5" />
                      <span>Upgrade</span>
                    </router-link>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white shadow rounded-lg border border-gray-200">
        <div class="h-full block">
          <div class="">
            <img
              src="https://i.ibb.co/Q6NMd4R/upgrade-3.png"
              class="block cursor-pointer w-full h-auto border-b rounded-tl-lg rounded-tr-lg"
              alt="SparkLayer"
              tabindex="0"
              @click="openArchbee('LhKqO8T7-A0HaRgVYFgtT')"
              @keyup.enter.space="openArchbee('LhKqO8T7-A0HaRgVYFgtT')"
            >
            <div class="p-6">
              <dl>
                <dt class="text-sm font-medium text-gray-600">
                  API Access
                </dt>
                <dd>
                  <div class="mt-1 mb-3 text-sm text-gray-500">
                    Build fully custom integrations and expand the power
                    of SparkLayer with our Open API framework.
                    <a
                      rel="noopener noreferrer"
                      class="font-medium inline-flex items-center cursor-pointer text-indigo-600 hover:text-indigo-500"
                      tabindex="0"
                      @click="openArchbee('LhKqO8T7-A0HaRgVYFgtT')"
                      @keyup.enter.space="openArchbee('LhKqO8T7-A0HaRgVYFgtT')"
                    >
                      <span>Learn more</span>
                      <ExternalLinkIcon class="group-hover:text-spark-purple ml-1 h-4 w-4" />
                    </a>
                  </div>
                  <div class="md:flex block gap-3">
                    <router-link
                      to="/settings/plan"
                      class="inline-flex items-center cursor-pointer trigger-intercom-install px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <SparklesIcon class="group-hover:text-spark-purple mr-2 h-5 w-5" />
                      <span>Upgrade</span>
                    </router-link>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ExternalLinkIcon, SparklesIcon } from '@heroicons/vue/outline';

export default {
  components: {
    ExternalLinkIcon,
    SparklesIcon,
  },
};
</script>
